// @storybook-skip: internal section of LessonsHomeScreen; covered by its screen story
import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import Box from "../Box";
import { LessonListItem } from "./LessonListItem";
import type { CompletedLesson } from "./types";

type Props = {
	title?: string;
	lessons: CompletedLesson[];
	onLessonPress: (lesson: CompletedLesson) => void;
};

export const CompletedLessonsSection = ({
	title,
	lessons,
	onLessonPress,
}: Props) => {
	const { t } = useTranslation();

	if (lessons.length === 0) {
		return null;
	}

	return (
		<Box gap={16}>
			<Box paddingHorizontal={16}>
				<Text variant="titleLarge">
					{title ?? t("lessons.home.completed.title")}
				</Text>
			</Box>
			<Box gap={16} paddingHorizontal={16}>
				{lessons.map((lesson) => (
					<LessonListItem
						key={lesson.id}
						lesson={lesson}
						onPress={onLessonPress}
					/>
				))}
			</Box>
		</Box>
	);
};
